import { render } from "./SlidoView.vue?vue&type=template&id=b3c2e660&scoped=true"
import script from "./SlidoView.vue?vue&type=script&lang=js"
export * from "./SlidoView.vue?vue&type=script&lang=js"

import "./SlidoView.vue?vue&type=style&index=0&id=b3c2e660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c2e660"]])

export default __exports__